<template>
  <div>
    <h3>Onlineangebot anfordern</h3>

    <div v-if="!identityToken">

      <h4>Ihre Daten</h4>

      <div class="form-row">

        <div class="form-group col-md-6">
          <label class="form-label" for="firstname">Vorname:</label>
          <input type="text" v-model="formData.firstname" class="form-control" id="firstname" name="firstname">
        </div>

        <div class="form-group col-md-6">
          <label class="form-label" for="lastname">Name<span class="text-danger">*</span>:</label>
          <input type="text" v-model="formData.lastname" class="form-control" id="lastname" name="lastname">
          <div class="invalid-feedback d-block" v-if="formerrors.includes('lastname')">
            Bitte geben Sie Ihren Namen an.
          </div>
        </div>

      </div>

      <div class="form-row">
        <div class="form-group col-md-6">
          <label class="form-label" for="mobile">Mobilnummer<span class="text-danger">*</span>:</label>
          <vue-tel-input
              v-model="formData.mobile"
              :preferred-countries="['de', 'at', 'ch']"
              :default-country="'de'"
              placeholder="Mobilnummer eingeben"
              :input-options="{
                id: 'mobile',
                name: 'mobile',
                class: 'form-control'
              }"
              @validate="onPhoneValidate"
              @input="onPhoneInput"
              mode="international"
              :auto-format="true"
              :format-on-display="true"
              :include-country-code="true"
          ></vue-tel-input>
          <div class="invalid-feedback d-block" v-if="formerrors.includes('mobile')">
            Bitte geben Sie eine gültige Mobilnummer an.
          </div>
        </div>

        <div class="form-group col-md-6">
          <label class="form-label" for="email">E-Mail:</label>
          <input type="email" v-model="formData.email" class="form-control" id="email" name="email">
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-6">
          <label class="form-label" for="licenseplate">Kennzeichen<span class="text-danger">*</span>:</label>
          <input type="text" v-model="formData.licenseplate" class="form-control" id="licenseplate" name="licenseplate">
          <div class="invalid-feedback d-block" v-if="formerrors.includes('licenseplate')">
            Bitte geben Sie Ihr Kennzeichen an.
          </div>
        </div>
        <div class="form-group col-md-6">
          <label class="form-label" for="manufacturer">Hersteller<span class="text-danger">*</span>:</label>
          <input type="text" v-model="formData.manufacturer" class="form-control" id="manufacturer" name="manufacturer">
          <div class="invalid-feedback d-block" v-if="formerrors.includes('manufacturer')">
            Bitte geben Sie den Hersteller an.
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-6">
          <label class="form-label" for="model">Modell:</label>
          <input type="text" v-model="formData.model" class="form-control" id="model" name="model">
        </div>
      </div>

    </div>

    <div v-if="identityToken">
      <KSRShopAccount
        :studioId="studioId"
        :identityToken="identityToken"
        @account-status-changed="onAccountStatusChanged"
      />

      <template v-if="accountStatus && accountStatus !== 10">
        <div class="form-row">
          <div class="col-md-12">
            <p><strong><u>Bitte ergänzen Sie noch folgende Daten zu Ihrem Fahrzeug:</u></strong></p>
          </div>
        </div>

        <KSRSelectVehicle @setvehicle="setVehicle" :kit="identityToken" />

        <div class="invalid-feedback d-block invalid-vehicle" v-if="formerrors.includes('licenseplate')">
          Bitte wählen Sie ein Fahrzeug aus.
        </div>
      </template>
    </div>

<template v-if="!identityToken || (accountStatus && accountStatus !== 10)">
      <div class="mb-2">
        <KSRUploadDocuments :kit="identityToken" :damageToken="tempToken" :storeId="studioId" :jobId="null" :embedded="true" ref="uploadDocumentsChild" :content="content" @damageWindowOpen="isDamageWindowOpen" :parent_formerrors="formerrors" />
      </div>

      <div class="form-group">
        <label class="form-label" for="description">Schadenbeschreibung<span class="text-danger">*</span>:</label>
        <textarea name="description" id="description" v-model="formData.description" class="form-control"></textarea>
        <p class="small text-muted" v-if="!formerrors.includes('description')">Bitte geben Sie hier eine möglichst präzise Beschreibung Ihres Schadens an.</p>
        <div class="invalid-feedback d-block" v-if="formerrors.includes('description')">
          Bitte geben Sie hier eine möglichst präzise Beschreibung Ihres Schadens an.
        </div>
      </div>

      <div class="form-group">
        <label class="form-label" for="infos">Wie und wann können wir Sie für Rückfragen erreichen<span class="text-danger">*</span>:</label>
        <textarea name="infos" id="infos" v-model="formData.infos" class="form-control"></textarea>
        <div class="invalid-feedback d-block" v-if="formerrors.includes('infos')">
          Bitte geben Sie Infos für evtl. Rückfragen an.
        </div>
      </div>

      <div class="form-group">
        <label class="form-label">Ich wünsche</label>

        <div class="form-check">
          <input class="form-check-input" v-model="formData.offerviaemail" type="checkbox" id="offerviaemail">
          <label class="form-check-label" for="offerviaemail">
            ein Angebot per E-Mail
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" v-model="formData.appointment" type="checkbox" id="appointment">
          <label class="form-check-label" for="appointment">
            einen möglichen Reparaturtermin
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" v-model="formData.replacementvehicle" type="checkbox" id="replacementvehicle">
          <label class="form-check-label" for="replacementvehicle">
            Ich benötige einen Ersatzwagen während der Reparatur
          </label>
        </div>

      </div>
    </template>

    <div v-if="identityToken && accountStatus && accountStatus !== 10">
      <div class="form-row">
        <div class="form-group col-md-12">
          <div class="d-sm-flex justify-content-between">
            <button class="btn btn-secondary my-3 mr-2" @click="logoutAndBack()">Abmelden und zurück</button>
            <button class="btn btn-primary my-3" @click="onSubmit()" :disabled="isSubmitting || hideSubmitButton">
              <span v-if="isSubmitting">Wird gesendet...</span>
              <span v-else>Onlineangebot anfordern</span>
            </button>
          </div>
        </div>
      </div>

      <div class="mt-2 text-danger"><small>* = Erforderlich</small></div>

    </div>

    <div v-if="!identityToken">
      <div class="form-row">
        <div class="form-group col-md-12">
          <div class="d-flex justify-content-between">
            <button class="btn btn-secondary my-3 mr-2" @click="goBack()">Zurück</button>
            <button class="btn btn-primary my-3" @click="onSubmitGuest()" :disabled="isSubmitting || showPhoneVerificationBox || hideSubmitButton">
              <span v-if="isSubmitting">Wird gesendet...</span>
              <span v-else>Onlineangebot anfordern</span>
            </button>
          </div>
        </div>
      </div>

      <div class="mt-2 text-danger"><small>* = Erforderlich</small></div>

    </div>

    <div v-if="showPhoneVerificationBox && !waitForBookingConfirmation">
      <KSRPhoneVerification @verficationStatus="onVerficationStatus"></KSRPhoneVerification>
      <div v-if="verificationError" class="alert alert-dark mt-3">
        {{ verificationError }}
      </div>
    </div>

    <div v-if="waitForBookingConfirmation" class="loading-container">
      <div class="spinner"></div>
      <p class="loading-text">Bitte warten...</p>
    </div>

    <div v-if="apiError" class="alert alert-dark mt-3">
      {{ apiError }}
    </div>

  </div>
</template>

<script>
import KSRPhoneVerification from "./KSRPhoneVerification.vue";
import KSRUploadDocuments from "./KSRUploadDocuments";
import KSRSelectVehicle from "./KSRSelectVehicle.vue";
import KSRShopAccount from "./KSRShopAccount.vue";

export default {
  name: 'KSROnlineOfferForm',
  components: { KSRPhoneVerification, KSRUploadDocuments, KSRSelectVehicle, KSRShopAccount },
  data() {
    return {
      studioId: false,
      content: false,
      formData: {
        lastname: '',
        firstname: '',
        mobile: '',
        email: '',
        manufacturer: '',
        model: '',
        description: '',
        infos:'',
        offerviaemail: false,
        appointment: '',
        replacementvehicle: false,
        brand: '',
        ez: '',
        licenseplate: '',
        vin: '',
        vehicleId: false
      },
      formerrors: [],
      isSubmitting: false,
      apiError: '',
      isPhoneValid: false,
      phoneObject: null,
      selectedSlotStart: '',
      typeDetails: {},
      insuranceData: {},
      showPhoneVerificationBox: false,
      verificationError: false,
      waitForBookingConfirmation: false,
      tempToken: null,
      identityToken: null,
      hideSubmitButton: false,
      accountStatus: null
    }
  },
  created() {
    this.studioId = this.$parent.studioId;
    this.loadFromLocalStorage();
    this.tempToken = Math.random().toString(36).substr(2) + Date.now().toString(36);
    this.identityToken = sessionStorage.getItem('identityToken');
  },
  mounted() {
    let _this = this;
    let url = '/api/ksr/'+this.studioId+'/content';
    axios.get(url)
        .then((response) => {
          _this.content = response.data;
        });
  },
  methods: {
    onAccountStatusChanged(status) {
      this.accountStatus = status;
    },
    loadFromLocalStorage() {
      try {
        this.selectedSlotStart = localStorage.getItem('selectedSlotStart') || '';

        const storedLicensePlate = localStorage.getItem('licensePlate') || '';
        if (storedLicensePlate && storedLicensePlate !== 'k') {
          this.formData.licenseplate = storedLicensePlate;
        }

        const storedTypeDetails = localStorage.getItem('typeDetails');
        if (storedTypeDetails) {
          this.typeDetails = JSON.parse(storedTypeDetails);
          if (this.typeDetails.manufacturer) {
            this.formData.manufacturer = this.typeDetails.manufacturer;
          }
          if (this.typeDetails.model) {
            this.formData.model = this.typeDetails.model;
          }
        }

        const storedInsuranceData = localStorage.getItem('insuranceData');
        if (storedInsuranceData) {
          this.insuranceData = JSON.parse(storedInsuranceData);
        }
      } catch (error) {
        console.error('Error loading from localStorage:', error);
      }
    },
    setVehicle(vehicle) {
      if(!vehicle) {
        this.formData.brand = '';
        this.formData.model = '';
        this.formData.ez = '';
        this.formData.licenseplate = '';
        this.formData.vin = '';
        this.formData.vehicleId = false
      }

      this.formData.brand = vehicle.brand;
      this.formData.model = vehicle.model;
      if(vehicle.registration_date) {
        this.formData.ez = moment(vehicle.registration_date).format('YYYY-MM-DD');
      }
      this.formData.licenseplate = vehicle.licenseplate;
      this.formData.vin = vehicle.vin;
      this.formData.vehicleId = vehicle.id;
    },
    async onSubmitGuest() {
      this.formerrors = [];
      this.apiError = '';
      if (this.formData.lastname === '') {
        this.formerrors.push('lastname');
      }
      if (this.formData.mobile === '' || !this.isPhoneValid) {
        this.formerrors.push('mobile');
      }
      if (this.formData.licenseplate === '') {
        this.formerrors.push('licenseplate');
      }
      if (this.formData.manufacturer === '') {
        this.formerrors.push('manufacturer');
      }
      if (this.formData.description === '') {
        this.formerrors.push('description');
      }
      if (this.formData.infos === '') {
        this.formerrors.push('infos');
      }

      if(this.content.setting_onlineoffer_registration_required) {
        if (this.$refs.uploadDocumentsChild && this.$refs.uploadDocumentsChild.formdata.files_registration.length == 0) {
          this.formerrors.push('registration_document');
        }
      }

      if(this.content.setting_onlineoffer_damage_required) {
        if (this.$refs.uploadDocumentsChild && !this.$refs.uploadDocumentsChild.formdata.damageId) {
          this.formerrors.push('damage_images');
        }
      }

      if (this.formerrors.length > 0) {
        return;
      }

      this.isSubmitting = true;

      try {
        const appointmentData = {
          ...this.formData,
          selectedSlotStart: this.selectedSlotStart,
          typeDetails: this.typeDetails,
          insuranceData: this.insuranceData,
          store_id: this.studioId
        };

        const response = await fetch('/api/appointment/send-verification', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
          },
          body: JSON.stringify(appointmentData)
        });

        const data = await response.json();

        if (response.ok) {
          localStorage.setItem('verificationToken', data.verification_token);
          this.showPhoneVerificationBox = true;
        } else {
          this.apiError = data.message || 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.';
        }
      } catch (error) {
        console.error('API Error:', error);
        this.apiError = 'Verbindungsfehler. Bitte prüfen Sie Ihre Internetverbindung.';
      } finally {
        this.isSubmitting = false;
      }
    },
    logoutAndBack() {
      sessionStorage.removeItem('identityToken');
      this.identityToken = false;
      this.$router.push('/online-offer-checkout/create');
    },
    goBack() {
      this.$router.push('/online-offer-checkout/create');
    },
    isDamageWindowOpen(value) {
      this.hideSubmitButton = value;
    },
    onPhoneValidate(phoneObject) {
      console.log('Phone validation:', phoneObject);
      this.isPhoneValid = phoneObject.valid;
      this.phoneObject = phoneObject;
    },
    onPhoneInput(formattedNumber, phoneObject) {
      console.log('Phone input - Formatted:', formattedNumber);
      console.log('Phone input - Object:', phoneObject);

      if (phoneObject && phoneObject.valid) {
        this.formData.mobile = phoneObject.formatInternational || formattedNumber;
        this.isPhoneValid = true;
        this.phoneObject = phoneObject;
      } else {
        this.formData.mobile = formattedNumber;
        this.isPhoneValid = false;
      }
    },
    async onVerficationStatus(payload) {
      console.log(payload);

      if(payload.message == 'success') {
        this.waitForBookingConfirmation = true;

        let uploadDocumentsChildFormdata = this.$refs.uploadDocumentsChild.formdata;
        let registrationDocumentFiles = Array.isArray(uploadDocumentsChildFormdata.files_registration) ? uploadDocumentsChildFormdata.files_registration : undefined;
        
        const appointmentData = {
          formdata: this.formData,
          typeDetails: this.typeDetails,
          insuranceData: this.insuranceData,
          damageToken: this.tempToken,
          registrationDocumentFiles: registrationDocumentFiles
        };

        try {
          const response = await fetch(`/api/ksr/${this.studioId}/guest-online-offer/confirm`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify(appointmentData)
          });

          const result = await response.json();

          console.log(result);

          this.waitForBookingConfirmation = false;

          if (response.ok) {
            console.log('Appointment confirmed successfully:', result);
            await this.$router.push('/thank-you');
          } else {
            console.error('Error confirming appointment:', result);
            this.apiError = result.message || 'An error occurred while confirming the appointment. Please try again.';
          }
        } catch (error) {
          console.error('Network Error:', error);
          this.apiError = 'Connection error. Please check your internet connection.';
          this.waitForBookingConfirmation = false;
        }
      }
      else {
        this.verificationError = payload.message;
        this.waitForBookingConfirmation = false;
      }
    },
    onSubmit() {
      this.formerrors = [];
      this.apiError = '';
      if (this.formData.licenseplate === '') {
        this.formerrors.push('licenseplate');
      }
      if (this.formData.description === '') {
        this.formerrors.push('description');
      }
      if (this.formData.infos === '') {
        this.formerrors.push('infos');
      }

      if(this.content.setting_onlineoffer_registration_required) {
        if (this.$refs.uploadDocumentsChild && this.$refs.uploadDocumentsChild.formdata.files_registration.length == 0) {
          this.formerrors.push('registration_document');
        }
      }

      if(this.content.setting_onlineoffer_damage_required) {
        if (this.$refs.uploadDocumentsChild && !this.$refs.uploadDocumentsChild.formdata.damageId) {
          this.formerrors.push('damage_images');
        }
      }

        if(!this.formerrors.length) {
          this.isSubmitting = true;
          var _this = this;

          if(this.identityToken) {
            let data = {
              formdata: this.formData,
              formdata_offer: this.formData,
              insuranceData: this.insuranceData
            };

            console.log(data);

            axios.post('/api/ksr/'+this.studioId+'/offer/kit/confirm?identityToken='+this.identityToken, data)
                .catch(function (error) {
                })
                .then((response) => {
                  let uploadDocumentsChildFormdata = this.$refs.uploadDocumentsChild.formdata;
                  let jobId = response.data;

                  console.log(uploadDocumentsChildFormdata);
                  console.log(jobId);

                  uploadDocumentsChildFormdata.jobId = jobId;
                  if(uploadDocumentsChildFormdata && jobId) {
                    let data = {
                      formdata: uploadDocumentsChildFormdata,
                      suppressMail: true
                    }
                    axios.post('/api/ksr/upload/documents/send?identityToken='+this.identityToken, data)
                        .then(() => {
                          _this.$refs.uploadDocumentsChild.formdata.files_registration = [];
                          _this.$refs.uploadDocumentsChild.resetChild();
                          this.$router.push('/thank-you');
                        });
                  }
                  else {
                    this.$router.push('/thank-you');
                  }
                });
          }
        }
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}
.vue-tel-input {
  height: 50px;
  border: 1px solid #dee2e6;
}
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  min-height: 200px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  color: #6c757d;
  font-size: 1rem;
  margin: 0;
  text-align: center;
}
</style>
